import { createFileRoute } from "@tanstack/react-router";
import { TransactionDebugger } from "@/pages/3d/debug/TransactionDebugger";

export const Route = createFileRoute("/demo/3d/debug/transaction-debugger")({
  component: TransactionDebugger,
});
